import styled from 'styled-components';

export const ProSkill = ({ text, title }) => {
  return (
    <ProSkillStyled>
      <h3 style={{ color: 'var(--primary-color)' }}>{title}</h3>
      <p>{text}</p>
    </ProSkillStyled>
  );
};

const ProSkillStyled = styled.div`
  background-color: var(--background-item-portfolio);
  color: #fff;
  padding: 1rem;
  text-align: left;
  border-left: 4px solid var(--primary-color);

  border-left: 6px solid var(--border-color);
  position: relative;
  width: 100%;
  p {
    padding: 1rem 0;
  }

  transition: all 0.2s ease-in-out;
  &:hover {
    border-left: 6px solid var(--primary-color);
    transform: translateY(3px);
  }
`;
